"use strict";
// @ts-nocheck
class LoginBox {
    constructor(node) {
        this.rootElement = node;
        this.rootElement.addEventListener('click', this.onClick.bind(this));
        this.loginContainer = this.rootElement.closest('.c-user-navigation__login');
        this.body = this.rootElement.closest('body');
        this.body.addEventListener('click', this.resetOnWebsiteClick.bind(this));
    }
    onClick(event) {
        event.preventDefault();
        const loginBox = this.loginContainer.querySelector('.c-login__flyout');
        if (event.target.classList.contains('c-icon')
            || event.target.classList.contains('c-user-login-button__text')) {
            if (loginBox.classList.contains('is-hidden')) {
                loginBox.classList.remove('is-hidden');
            }
            else {
                loginBox.classList.add('is-hidden');
            }
        }
    }
    resetOnWebsiteClick(event) {
        const loginBox = this.loginContainer.querySelector('.c-login__flyout');
        if (!event.target.classList.contains('c-icon')
            && !event.target.classList.contains('c-user-login-button__text')
            && !(event.target.closest('.c-login__flyout'))
            && !loginBox.classList.contains('is-hidden')) {
            loginBox.classList.add('is-hidden');
            this.body.removeEventListener('click', this.resetOnWebsiteClick.bind(this));
        }
    }
}
const loginBoxes = document.querySelectorAll('.js-login');
loginBoxes.forEach((loginBox) => {
    new LoginBox(loginBox);
});
